import { Suspense, lazy } from "react";

import { Route } from "react-router-dom";

import Loader from "shared/uikit/Loader";

import { routes } from "./constants";

const BasicLayout = lazy(() => import("shared/templates/Layouts/BasicLayout"));

const DerivativesPoolsPage = lazy(() => import("./Pages/Derivatives/Pools"));
const DerivativesTradingPage = lazy(() => import("./Pages/Derivatives/Trading"));
const DerivativesAccountPage = lazy(() => import("./Pages/Derivatives/AccountDetails"));

const MemberRoutes = () => {
	const getPublicRoutes = () => [
		<Route
			key={routes.derivatives.pools.getElementKey()}
			path={routes.derivatives.pools.getPath()}
			element={
				<Suspense fallback={<Loader wrapper />}>
					<DerivativesPoolsPage />
				</Suspense>
			}
		/>,
		<Route
			key={routes.derivatives.account.getElementKey()}
			path={routes.derivatives.account.getPath()}
			element={
				<Suspense fallback={<Loader wrapper />}>
					<DerivativesAccountPage />
				</Suspense>
			}
		/>,
		<Route
			key={`${routes.derivatives.pools.getElementKey()}/marketId`}
			path={`${routes.derivatives.pools.getPath()}/:marketId`}
			element={
				<Suspense fallback={<Loader wrapper />}>
					<DerivativesTradingPage />
				</Suspense>
			}
		/>
	];

	return [
		<Route
			key="derivatives-routes-root"
			element={
				<Suspense fallback={<Loader wrapper />}>
					<BasicLayout mainClassName="pt-16!" outletWrapperClassName="p-4" />
				</Suspense>
			}
		>
			{getPublicRoutes()}
		</Route>
	];
};

export default MemberRoutes;
